import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStatus = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10,
			y1: 8,
			x2: 10,
			y2: 16
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 14,
			y1: 8,
			x2: 14,
			y2: 16
		})
	]
});
export default SvgIconStatus;
